import {createApp, h} from 'vue';
import {createInertiaApp, Link} from '@inertiajs/inertia-vue3';
import {InertiaProgress} from '@inertiajs/progress';
import {ZiggyVue} from '../../vendor/tightenco/ziggy/dist/vue';
import {Ziggy} from '../../vendor/tightenco/ziggy/dist/index';
import Layout from '@/Shared/Layout';
import {Inertia} from "@inertiajs/inertia";

// Vue.prototype.$route = route

createInertiaApp({
    resolve: async name => {
        const page = (await import(`./Pages/${name}`)).default;

        if (page.layout === undefined) {
            page.layout = Layout;
        }

        return page;
    },
    setup({el, App, props, plugin}) {
        createApp({render: () => h(App, props)})
            .use(plugin)
            .component('NavLink', Link)
            .mixin({
                mounted() {
                    feather.replace();
                }
            })
            .use(ZiggyVue, Ziggy)
            .mount(el);
    },
});

Inertia.on('start', (event) => {
    cash("#programmatically-dropdown").dropdown("hide");
})

InertiaProgress.init({
    color: 'red',
    showSpinner: true,
});
